import WithRender from "../../templates/base/pageOptionAttributes.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductOptionsSelection", "getShowTooltipsInPOV"]),
    name: function () {
      return this.propsData.label;
    },
    value: function () {
      return this.propsData.value;
    },
    imageSrc: function () {
      if (this.propsData.image) {
        return this.propsData.image;
      }
      return null;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOV && this.propsData.tooltip;
    }
  },
  methods: {
    ...mapActions(["setPageOption"]),
    activeClass: function () {
      var selectedItems = this.getActiveProductOptionsSelection;
      return selectedItems.includes(this.value) ? "active" : "";
    }
  },
  props: ["propsData"]
});
